import { ReactComponent as MyMoneyXLogo } from 'assets/brand/moneyx-sidebar.svg';
import { ReactComponent as MyAriyanaLogo } from 'assets/brand/sample.svg';
import * as MyApiAuthorizationConstants from 'framework/base/authorization/ApiAuthorizationConstants';
import MyAuthorizationProvider, {
  useAuth as myUseAuth
} from 'framework/base/authorization/AuthorizationProvider';
import myAuthService from 'framework/base/authorization/AuthorizeService';
import MyAuthRouteGuard from 'framework/base/authorization/AuthRouteGuard';
import MyLoginCallbackHandler from 'framework/base/authorization/LoginCallbackHandler';
import MyNoHashQueryStringUtils from 'framework/base/authorization/noHashQueryStringUtils';

/* ****************** Instances ********************** */
export const AriyanaLogo = MyAriyanaLogo;
export const MoneyXLogo = MyMoneyXLogo;

/* ****************** Authorization Instances ********************** */
export const ApiAuthorizationConstants = MyApiAuthorizationConstants;
export const AuthorizationProvider = MyAuthorizationProvider;
export const useAuth = myUseAuth;
export const authService = myAuthService;
export const AuthRouteGuard = MyAuthRouteGuard;
export const LoginCallbackHandler = MyLoginCallbackHandler;
export const NoHashQueryStringUtils = MyNoHashQueryStringUtils;

/* ****************** Authorization spec ********************** */
export const getPostLoginCallbackRoute = () =>
  sessionStorage.getItem('originalPath') || '/';

/* ****************** theme spec ********************** */
export const componentSizesExtraVars = {
  common: {},
  desktop: {},
  laptop: {},
  tablet: {},
  mobile: {}
};

/* ****************** styles spec ********************** */
export const sidebarDrawerPaperStyles = (MuiStyled, MuiDrawer) =>
  MuiStyled(MuiDrawer)`
    flex-basis: ${(props) =>
      props.open
        ? props.theme?.componentSizes?.sidebar?.opened?.width || '240px'
        : props.theme?.componentSizes?.sidebar?.closed?.width || '64px'};
    border-radius: 1rem; 
    .MuiDrawer-paper {
      top: auto;
      left: auto;
      max-height: 98dvh;
      position: fixed;
      border-radius: 1rem;
      padding: ${(props) =>
        props.drawerOpen ? '1.25rem 1rem' : '1.25rem 0.5rem'};
      overflow-x: hidden;
      background: ${(props) =>
        sidebarTheme === 'blue'
          ? props.theme?.sidebar?.blueBackground || '#1a1a1a'
          : props.theme?.sidebar?.background || '#1a1a1a'};
      width: ${(props) =>
        props.open
          ? props.theme?.componentSizes?.sidebar?.opened?.width || '240px'
          : props.theme?.componentSizes?.sidebar?.closed?.width || '64px'};
    }

    & .MuiDrawer-paper {
      transition: ${(props) =>
        props.theme?.transitions?.create
          ? props.theme.transitions.create('width', {
              easing:
                props.theme?.transitions?.easing?.sharp ||
                'cubic-bezier(0.4, 0, 0.6, 1)',
              duration: props.open
                ? props.theme?.transitions?.duration?.leavingScreen || 195
                : props.theme?.transitions?.duration?.enteringScreen || 225
            })
          : 'width 0.3s ease'};
    }
  `;

export const sidebarMobileDrawerStyles = (MuiStyled, MuiDrawer) =>
  MuiStyled(MuiDrawer)`
    position: absolute;
    z-index: 1200;
    .MuiDrawer-paper {
      overflow-x: hidden;
      padding: ${(props) => (props.open ? '1.25rem 1rem' : '0')};
      border-bottom-right-radius: 1rem;
      border-top-right-radius: 1rem;
      background: ${(props) =>
        sidebarTheme === 'blue'
          ? props.theme?.sidebar?.blueBackground || '#1a1a1a'
          : props.theme?.sidebar?.background || '#1a1a1a'};
      width: ${(props) =>
        props.open ? props.theme.componentSizes.sidebar.width : 0};
      background-color: ${(props) => props.theme.sidebar.background};
    }

    & .MuiDrawer-paper {
      transition: ${(props) =>
        props.theme.transitions.create('width', {
          easing: props.theme.transitions.easing.sharp,
          duration: props.open
            ? props.theme.transitions.duration.leavingScreen
            : props.theme.transitions.duration.enteringScreen
        })};
    }
  `;

export const sidebarTheme = 'dark';
export const idSidebarClosable = true;

/* ****************** environment spec ********************** */
export const imageAddressPrefix = '/';
export const openNewWindow = window.open;
export const getQueryStringsFromLocation = () =>
  window.location.search.substring(1);
export const showSettingsInNavbar = true;
export const showSwitchOptionInNavbar = true;
export const showCreditInNavbar = true;
export const getWindowLocationPathname = () => window.location.pathname;
